
export enum DiscountType {
    marketDiscount,
    specialOffer
}

export enum DiscountStatus {
    Active, 
    Expired, 
    FutureStart,
    ExpiresInLessThan7Days,
    RequiresApproval
}